export default {
      id: "ic_save_dark-usage",
      viewBox: "0 0 16 16",
      url: "/" + "images/icons.3.109.2.svg#ic_save_dark-usage",
      toString: function () {
        return this.url;
      }
    }